<template>
  <div
    data-test-upload-box
    :data-upload-id="options.Id"
    data-upload-target
    style="width: 100%"
  >
    <div data-uploads class="is-hidden"></div>
    <input type="hidden" name="filesJson" value="[]" />
    <input
      :id="options.HasFileCheckboxId"
      class="is-hidden"
      type="checkbox"
      name="hasFile"
      :required="options.Required"
    />
    <div
      class="dropzone__header dropzone__header--large"
      data-js-dropzone-clickable
      data-test-dropzone="header"
    >
      <img
        class="dropzone__file-upload-image"
        :src="icons.uploader.upload"
        alt="File upload"
      />
      <p class="dropzone__message dz-message" style="margin: auto">
        Legen Sie Ihre Dateien hier ab&nbsp;<span class="dropzone__message-link"
          >oder <a>zum Hochladen klicken</a></span
        >
        <br />
        <span class="text-center">
          {{ GetUploaderInstructionalCopy() }}
        </span>
      </p>
    </div>
    <div style="display: none" data-preview-template>
      <div class="dropzone__upload-preview">
        <div class="dropzone__preview-left small-6 medium-4">
          <div class="dropzone__image">
            <img data-dz-thumbnail="" alt="dz-thumbnail" />
          </div>
          <span class="dropzone__filename" data-dz-name=""></span>
        </div>
        <div
          class="dropzone__preview-right small-6 medium-8"
          style="justify-content: space-between"
        >
          <div class="dropzone__progress progress" data-js-dropzone-progress>
            <span
              class="dz-upload progress-meter"
              data-dz-uploadprogress=""
            ></span>
          </div>
          <div class="small-8 medium-10">
            <div class="dropzone__error text-left">
              <div class="dz-error-mark">
                <span>Upload fehlgeschlagen!</span>
              </div>
              <span data-dz-errormessage></span>
            </div>
          </div>
          <div
            data-js-dropzone-preview-right-ui
            class="hide flex-container align-right shrink small-2"
          >
            <span class="dropzone__size" data-dz-size=""></span>
            <img
              class="dropzone__remove"
              height="16"
              width="16"
              :src="icons.uploader.delete"
              alt="Delete icon"
              data-dz-remove
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    (function (options) {
      window.require(['www'], function () {
        window.require(['app/fileUploader'], function (fileUploader) {
          fileUploader.inititalise(options);
        });
      });
    })(this.options);
  },
  methods: {
    GetUploaderInstructionalCopy() {
      if (this.options.PixelLimits)
        if (this.options.AcceptedFileExtensionsDisplay === '*.*')
          return `Wir akzeptieren ${this.options.MaxFiles} Datei(en) bis zu ${this.options.MaxFileSize}MB und ${this.options.PixelLimits.MaxWidth} x ${this.options.PixelLimits.MaxHeight} Pixel jeglichen Typs`;
        else
          return `Wir akzeptieren ${this.options.MaxFiles} Datei(en) bis zu ${this.options.MaxFileSize}MB und ${this.options.PixelLimits.MaxWidth} x ${this.options.PixelLimits.MaxHeight} Pixel vom Typ ${this.options.AcceptedFileExtensionsDisplay}`;
      return `Wir können ${this.options.MaxFiles} Dateien bis ${this.options.MaxFileSize}MB von Art ${this.options.AcceptedFileExtensionsDisplay} px aufnehmen`;
    },
  },
};
</script>
